<template>
  <div v-html="content.dsc_texto" :style="style"></div>
</template>

<script>
export default {
  props: {
    content: Object,
    portal: String,
    markColor: {
      type: String,
      default: "#FAFA2F",
    },
    markOpacity: {
      type: Number,
      default: 0.3,
    },
  },
  data() {
    return {};
  },
  computed: {
    style() {
      const portalStyle =
        this.portal === "oglobo"
          ? "font-family: 'Times New Roman, Times, serif'; color: #000; font-weight: 400; font-size: 1.3rem;"
          : "font-family: 'Globotipo Texto', sans-serif !important'; color: #333333; font-weight: 500; font-size: 1.265rem;";

      const rgb = this.hexToRgb(this.markColor);
      const background = rgb
        ? `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${this.markOpacity})`
        : this.markColor;
      return `${portalStyle} --mark-background-color: ${background};`;
    },
  },
  methods: {
    hexToRgb(hex) {
      let c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return {
          r: (c >> 16) & 255,
          g: (c >> 8) & 255,
          b: c & 255,
        };
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  width: 90%;
  line-height: 2rem;

  &::v-deep mark {
    background-color: var(--mark-background-color);
    color: inherit;
    padding: 0 2px;
  }
}
</style>
